import "./spinner.scss";
// Loaded as <img> (not inlined via SVGR): the logo's clipPath ids would otherwise
// collide with other inline instances and the round clip can break (square spinner)
import daexLogoUrl from "@icons/DaexLogo.svg";

// inline: sits in the content area instead of covering the whole screen
export default function Spinner({ inline = false }: { inline?: boolean }) {
  return (
    <div className={`loadingSpinnerContainer${inline ? " inline" : ""}`}>
      <img
        src={daexLogoUrl}
        className="image__profile loadingSpinner"
        alt=""
        aria-hidden="true"
        decoding="async"
      />
    </div>
  );
}
